import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps } from "react";

const O365OneDrive32 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M18.336 16.688L23.952 13.6126C23.5514 11.8974 22.6747 10.2734 21.405 8.873C20.1353 7.47257 18.5653 6.38243 16.7196 6.10697C14.8738 5.8315 12.9412 6.19491 11.2006 6.98624C9.46003 7.77758 7.97021 8.98632 6.71835 10.4014L18.336 16.688Z"
                fill="#0364B8"
            />
            <path
                d="M12.9616 12.1538C11.7091 11.388 10.2315 11.0757 8.77621 11.2692C7.3209 11.4627 5.9763 12.1503 4.96747 13.2169C3.95864 14.2836 3.34707 15.6642 3.2345 17.128C3.12194 18.5918 3.51613 20.0498 4.35041 21.2576L13.4608 21.501L18.336 15.3729L12.9616 12.1538Z"
                fill="#0078D4"
            />
            <path
                d="M23.952 13.6129C23.1264 13.5553 22.3008 13.6968 21.5392 14.0257L18.336 15.3729L21.136 20.0802L28.1776 21.2674C28.5902 20.5013 28.8042 19.644 28.7997 18.7739C28.7952 17.9039 28.5723 17.0463 28.1517 16.2872C27.7312 15.528 27.1341 14.8907 26.392 14.4144C25.6498 13.938 24.7858 13.6381 23.9024 13.6129H23.952Z"
                fill="#1490DF"
            />
            <path
                d="M18.336 15.3726L4.35195 21.2575C4.94056 22.104 5.72529 22.7957 6.63915 23.2731C7.55301 23.7506 8.57044 24 9.59997 24H23.6C24.5386 24 25.4596 23.7459 26.2656 23.2672C27.0716 22.7884 27.7319 22.0955 28.1776 21.2672L18.336 15.3726Z"
                fill="#28A8EA"
            />
        </svg>
    );
};

const O365OneDrive24 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.752 12.516L17.964 10.2095C17.6755 9.08322 17.0661 8.06504 16.2097 7.27872C15.3533 6.49241 14.2869 5.97183 13.1402 5.78026C11.9935 5.58868 10.8159 5.7344 9.7504 6.19968C8.68497 6.66496 7.77766 7.42974 7.13876 8.40106L13.752 12.516Z"
                fill="#0364B8"
            />
            <path
                d="M9.72121 9.11534C8.78183 8.54096 7.67363 8.30673 6.58216 8.45189C5.4907 8.59706 4.48223 9.11275 3.7256 9.91267C2.96897 10.7126 2.51012 11.7482 2.42588 12.846C2.34163 13.9438 2.63709 15.0373 3.26281 15.9433L10.0956 16.1257L13.752 11.5297L9.72121 9.11534Z"
                fill="#0078D4"
            />
            <path
                d="M17.964 10.2097C17.3447 10.1665 16.7254 10.2727 16.1544 10.5193L13.752 11.5297L15.852 15.0601L21.1332 15.9506C21.4426 15.376 21.6032 14.733 21.5998 14.0804C21.5963 13.4279 21.4292 12.7866 21.1138 12.2154C20.7983 11.6442 20.3446 11.1612 19.794 10.8108C19.2436 10.4604 18.6139 10.2537 17.9628 10.2097H17.964Z"
                fill="#1490DF"
            />
            <path
                d="M13.752 11.5295L3.26397 15.9431C3.70542 16.578 4.29397 17.0967 4.97936 17.4548C5.66476 17.8128 6.42664 18 7.19996 18H17.7C18.4039 18 19.0947 17.8095 19.6992 17.4486C20.3037 17.0876 20.7991 16.5699 21.1332 15.9503L13.752 11.5295Z"
                fill="#28A8EA"
            />
        </svg>
    );
};

const O365OneDrive16 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M9.16808 8.34391L11.9761 6.80631C11.7838 6.05548 11.3774 5.37669 10.8065 4.85248C10.2356 4.32827 9.52473 3.98121 8.76026 3.8535C7.99578 3.72579 7.21067 3.82294 6.50038 4.13312C5.79008 4.4433 5.1852 4.95316 4.75928 5.60071L9.16808 8.34391Z"
                fill="#006DC0"
            />
            <path
                d="M6.48086 6.0767C5.8546 5.69378 5.1158 5.53763 4.38816 5.6344C3.66051 5.73116 2.9882 6.07497 2.48378 6.60826C1.97937 7.14154 1.67347 7.83193 1.6173 8.56382C1.56114 9.29572 1.75812 10.0247 2.17526 10.6287L6.73046 10.7503L9.16806 7.6863L6.48086 6.0767Z"
                fill="#0078D4"
            />
            <path
                d="M11.976 6.80656C11.5631 6.77776 11.1494 6.84854 10.7696 7.01296L9.16797 7.68656L10.568 10.0402L14.0888 10.6338C14.2951 10.2508 14.402 9.82211 14.3998 9.38708C14.3975 8.95204 14.2861 8.52453 14.0758 8.14371C13.8655 7.76288 13.563 7.44092 13.196 7.2073C12.829 6.97369 12.4092 6.8359 11.9752 6.80656H11.976Z"
                fill="#1490DF"
            />
            <path
                d="M9.16803 7.68652L2.17603 10.6289C2.47033 11.0522 2.8627 11.398 3.31962 11.6368C3.77655 11.8756 4.28447 12.0002 4.80003 12.0001H11.8C12.2693 12.0001 12.7299 11.8731 13.1329 11.6326C13.5358 11.392 13.8662 11.0468 14.0888 10.6337L9.16803 7.68652Z"
                fill="#28A8EA"
            />
        </svg>
    );
};

export const O365OneDriveIcon = createIcon(O365OneDrive16, O365OneDrive24, O365OneDrive32, "O365OneDriveIcon");
